/**
 * The strip above the table: the game's name, where in the game we are, what
 * kind of table this is, and whatever controls the room or the hot seat adds.
 */
import { MANIFESTS, type View } from '@trajan/engine';
import type { ReactNode } from 'react';

const ROMAN = ['I', 'II', 'III', 'IV'];

export function TopBar({
  view,
  note,
  children,
}: {
  view: View;
  note: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header className="topbar">
      <h1>Trajan</h1>
      <span className="topbar-where">
        {view.phase.kind === 'gameOver'
          ? 'The game is over'
          : view.phase.kind.startsWith('setup.')
            ? 'Setting up'
            : `Quarter ${ROMAN[view.time.quarter - 1] ?? view.time.quarter} · round ${view.time.round} of ${MANIFESTS.timeTrack.roundsPerQuarter}`}
      </span>
      <span className="topbar-note">{note}</span>
      <span className="topbar-end">{children}</span>
    </header>
  );
}
